import React from 'react';
import Translation from '../../../../Shared/components/Translation';
import Contact from './Contact';
import { ZdsDivider } from '@zig-design-system/ui-components-react';
const ContactList = ({ title, contacts }) => {
    if (contacts.every((contact) => Object.keys(contact).length === 0)) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("h2", { className: "zds-headline-md zds-margin-bottom-2" },
            React.createElement(Translation, { item: title })),
        contacts.map((contact, index) => (React.createElement(Contact, { contact: contact, key: index }))),
        React.createElement(ZdsDivider, { className: 'zds-margin-y-4 md:zds-margin-y-8' })));
};
export default ContactList;
